import { useQuery } from "@tanstack/react-query";
import type {
  IntegrationLogDirection,
  IntegrationLogListResponse,
  IntegrationLogStatus,
} from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

export type UseIntegrationLogsQueryParams = {
  limit?: number;
  offset?: number;
  search?: string;
  storeId?: string;
  status?: IntegrationLogStatus;
  provider?: string;
  direction?: IntegrationLogDirection;
  entityType?: string;
  dateFrom?: string;
  dateTo?: string;
};

function buildPath(params: UseIntegrationLogsQueryParams): string {
  const query = new URLSearchParams();
  if (params.limit !== undefined) {
    query.set("limit", String(params.limit));
  }
  if (params.offset !== undefined) {
    query.set("offset", String(params.offset));
  }
  if (params.search) {
    query.set("search", params.search);
  }
  if (params.storeId) {
    query.set("storeId", params.storeId);
  }
  if (params.status) {
    query.set("status", params.status);
  }
  if (params.provider) {
    query.set("provider", params.provider);
  }
  if (params.direction) {
    query.set("direction", params.direction);
  }
  if (params.entityType) {
    query.set("entityType", params.entityType);
  }
  if (params.dateFrom) {
    query.set("dateFrom", params.dateFrom);
  }
  if (params.dateTo) {
    query.set("dateTo", params.dateTo);
  }

  const queryString = query.toString();
  return queryString.length > 0
    ? `${endpoints.admin.integrationLogs}?${queryString}`
    : endpoints.admin.integrationLogs;
}

export function useIntegrationLogsQuery(
  params: UseIntegrationLogsQueryParams = {},
) {
  const query = useQuery({
    queryKey: queryKeys.admin.integrationLogs(params),
    queryFn: () => apiJsonClient<IntegrationLogListResponse>(buildPath(params)),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
